import { render, staticRenderFns } from "./ReceiveNew.vue?vue&type=template&id=ef7b31c0&"
import script from "./ReceiveNew.vue?vue&type=script&lang=js&"
export * from "./ReceiveNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports